import { Component, Input } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'app-epson-logo',
  templateUrl: './epson-logo.component.html',
  styleUrls: ['./epson-logo.component.scss'],
})
/**
 * Epson rewards circle logo
 */
export class EpsonLogoComponent {
  @Input() animate: boolean = false;
  private _small = false;

  /**
   * Get image src
   * @return {string}
   */
  getSrc(): string {
    if (this.small) {
      return '/assets/images/epson-rewards-logo-small.png';
    }
    return '/assets/images/epson-rewards-logo.png';
  }

  /**
   * Decides if the img src label is small
   * @return {boolean}
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets this img src as a small by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }
}
